import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ContactSection() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/contact", form);
      toast.success(r.data.message || "Message sent!");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "bg-transparent border-b-2 border-white/15 focus:border-primary outline-none py-4 w-full text-white placeholder:text-white/40 transition-colors";

  return (
    <section id="contact" data-testid="contact-section" className="px-6 md:px-12 lg:px-16 py-24 md:py-32 bg-background border-t border-white/10">
      <div className="grid lg:grid-cols-2 gap-16">
        <div>
          <p className="text-xs uppercase tracking-[0.35em] font-bold text-primary mb-6">Get in touch</p>
          <h2 className="font-anton text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.85] text-white">
            Questions?<br />Collabs?<br /><span className="text-primary">Say less.</span>
          </h2>
          <p className="text-white/55 mt-8 max-w-md leading-relaxed">
            Wholesale, custom team drops, or just wanna talk ball? Drop us a line and we'll get back within 24 hours.
          </p>
        </div>
        <form onSubmit={submit} className="space-y-6">
          <input
            data-testid="contact-name"
            value={form.name}
            onChange={set("name")}
            placeholder="Name"
            required
            className={inputCls}
          />
          <input
            data-testid="contact-email"
            type="email"
            value={form.email}
            onChange={set("email")}
            placeholder="Email"
            required
            className={inputCls}
          />
          <textarea
            data-testid="contact-message"
            value={form.message}
            onChange={set("message")}
            placeholder="Message"
            required
            rows={5}
            className={`${inputCls} resize-none`}
          />
          <button
            data-testid="contact-submit"
            type="submit"
            disabled={loading}
            className="bg-primary text-black hover:bg-white px-8 py-4 font-bold uppercase tracking-[0.2em] text-sm transition-colors active:scale-95 disabled:opacity-60"
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </section>
  );
}
